import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Util from './../../../../../../shared/util/util';
import Loader from './../../../../../../shared/components/loader'
import TripServices from './../../../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';


export default {
  name: 'firstmilemgmt',
  components: {
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    VueElementLoading,
    Loader
  },
  props:['lmtrip','lmtripid','pod'],
  data() {
    return {
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['AWB','STATUS','LMMPS','POD'],
      totalCount:0,
      offset: 0,
      hubimage: "",
      fieldImg: "",
      ShowPODImages: false,
      // innerTableColumn: ['Assigned Zones'],
      tableItems: [],
      podimgArr: [],
      hubimgArr: [],
      id:"",
      fieldcaption:"Field Image",
      hubcaption:"Hub Image",
      isLoading:false,
      mpslist:"",
      ShowMPSDetails:false,
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getLastMileList()
      // this.getPODImage();
  },
  methods: {
    async getLastMileList(){
      try{
        if(this.lmtrip.lastmile){
          this.tableItems = this.lmtrip.lastmile.map((el, index) => {
            let viewBnBdshipment
            if (el.ismpsallocation) {
              if (el.ismpsallocation.startsWith('BN') || el.ismpsallocation.startsWith('BD')) {
                viewBnBdshipment = el.ismpsallocation;
              } else {
                viewBnBdshipment = el.awb
              }
            } else {
              viewBnBdshipment = el.awb
            }
            return {
            'id':index+1,
            'AWB':viewBnBdshipment,
            'STATUS':el.awbstatus,
            'LMMPS':el.total_mps,
            'POD':"",
            }
          })

        }else{
          this.tableItems = []
        }

      }catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    closePODImages(){
      this.podimgArr = [];
      this.hubimgArr = [];
      this.ShowPODImages =false;
    },

    getCustomTableEvent(id){
      if (id.actionType == "viewmps")  {
        let tempdata = this.tableItems.find(item => item.AWB === id.id);
        this.mpslist = tempdata.LMMPS;
        this.ShowMPSDetails = true;
      }
      if (id.actionType == "viewimage")  {
        this.id = id.id
        this.getPODImage(this.id)
      this.ShowPODImages =true;
      }
    },
    async getPODImage(awbid) {
      try {
        this.isLoading = true
        this.pod.map((el)=>{
          if(awbid == el.awb){
            let podimagesarr = []
              if(el.podurl.podimages){
              Object.keys(el.podurl.podimages).forEach(key => {
                podimagesarr.push(el.podurl.podimages[key])})
              }
          this.podimgArr.push(el.podurl.destinationpodimg)
          this.hubimgArr.push(podimagesarr)
        }
        })
        // if(this.hubimgArr[0].length>0){
        //   this.hubimgArr[0]=this.hubimgArr[0]
        // }
        // else{
        //   this.hubimgArr[0][1]= ''
        // }
       this.isLoading = false
      } catch (err) {
        this.isLoading = false
       console.log(err);
      }
    },

    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
    openImage(image) {
      this.fieldImg = image
      this.$nextTick(() => {
        let modal = document.getElementById('myModalImg' + image);
        var img = document.getElementById('imgid' + image);
        var modalImg = document.getElementById("img" + image);
        var captionText = document.getElementById("captionImg" + this.fieldcaption);
        modal.style.display = "block";
        modalImg.src = image;
        captionText.innerHTML = this.fieldcaption;
        this.ShowPODImages =false;
			})
    },
    openImageHub(openImagehub) {
      this.hubimage = openImagehub;
      this.$nextTick(() => {
      let modal = document.getElementById('myModalImg' + openImagehub);
      var img = document.getElementById('imgid' + openImagehub);
      var modalImg = document.getElementById("img" + openImagehub);
      var captionText = document.getElementById("captionImg" + this.hubcaption);
      modal.style.display = "block";
      modalImg.src = openImagehub;
      captionText.innerHTML = this.hubcaption;
      this.ShowPODImages =false;
			})
    },
    closemodal(id) {
      let modal = document.getElementById(id);
      modal.style.display = "none";
      this.ShowPODImages =true;
    },
    closeMPSDetails(){
      this.ShowMPSDetails = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/TripManagementListing/TripMgmtFirstLastMiles/lastmile/lastmile.component.js